import { ModalsManager } from '@/components/modals/modalsManager';
import { Button } from '@/components/ui/Button';
import { YStack } from '@/components/ui/layout/layout';
import { getEnvVar } from '@/env';
import { SettingsSection } from '@/features/settings/settings-section';
import { TeamBaaAgreementModal } from '@/features/team/components/TeamBaaAgreementModal';

const BAA_PDF_URL = `${getEnvVar('VITE_API_URL')}/static/littlebird-baa.pdf`;

interface TeamBaaCardProps {
  teamId: string;
  baaEnabled: boolean;
}

export function TeamBaaCard({ teamId, baaEnabled }: TeamBaaCardProps) {
  const openBaaModal = () => {
    ModalsManager.show(TeamBaaAgreementModal, {
      teamId,
      resolve: () => {},
    });
  };

  return (
    <YStack className="w-full gap-3">
      <SettingsSection.GroupHeader>Compliance</SettingsSection.GroupHeader>
      <SettingsSection.Group>
        <SettingsSection.Item direction="horizontal">
          <SettingsSection.ItemHeader>
            <SettingsSection.ItemLabel>Enable HIPAA</SettingsSection.ItemLabel>
            <SettingsSection.ItemDescription>
              {baaEnabled
                ? 'Privacy mode is enforced for every team member.'
                : 'This is the HIPAA Business Associate Agreement (BAA) for your team.'}
            </SettingsSection.ItemDescription>
          </SettingsSection.ItemHeader>

          {baaEnabled ? (
            <Button
              variant="secondary"
              onClick={() =>
                window.open(BAA_PDF_URL, '_blank', 'noopener,noreferrer')
              }
              className="w-36"
            >
              View agreement
            </Button>
          ) : (
            <Button variant="secondary" onClick={openBaaModal} className="w-36">
              Enable HIPAA
            </Button>
          )}
        </SettingsSection.Item>
      </SettingsSection.Group>
    </YStack>
  );
}
